import { insideEU } from "./CountryUtils";
import { getCurrentSite } from "./SiteUtils";
import { divide, multiply } from "./NumberUtils";
import { accountTypes } from "../config/accountTypes";
import BigNumber from "bignumber.js";
import { CountryCode } from "countries-and-timezones";

export function showVat(
  accountType: "private" | "business" | "b2b",
  countryCode: CountryCode
) {
  if (accountType === accountTypes.b2b) return false;
  if (countryCode === "SE") return true;
  if (insideEU(countryCode) && accountType === accountTypes.privateAccount)
    return true;
  return false;
}

export const siteVatFactor = (function () {
  switch (getCurrentSite()) {
    default:
      return 1;
    case "uk":
      return 1.2;
    case "se":
    case "com":
      return 1.25;
  }
})();

export const addVat = (basePrice: BigNumber.Value) => {
  return multiply(basePrice, siteVatFactor);
};

export const removeVat = (price: BigNumber.Value) => {
  return divide(price, siteVatFactor);
};
